<template>
  <div class="retail_pagination" v-if="pagination">
    <p>{{ pageData.current_page }}-{{ pageData.to }} of {{ pageData.total }}</p>
    <ul>
      <!-- First Page -->
      <li>
        <a
            id="firstPage"
            :class="{ disabled: pageData.current_page === 1 }"
            @click="pageData.current_page > 1 && changePage(1)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevrons-left"><polyline points="11 17 6 12 11 7"></polyline><polyline points="18 17 13 12 18 7"></polyline></svg>
        </a>
      </li>

      <!-- Previous Page -->
      <li>
        <a
            id="prevPage"
            :class="{ disabled: pageData.current_page === 1 }"
            @click="pageData.current_page > 1 && changePage(pageData.current_page - 1)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 mr-[1px] lg:w-5 lg:h-5 lg:mr-[2px]">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5"></path>
          </svg>
        </a>
      </li>

      <!-- Dynamic Pages -->
      <li v-for="page in pagesNumber" :key="page">
        <a
            href="javascript:void(0)"
            :class="{ active: page === pageData.current_page }"
            @click="changePage(page)"
        >
          {{ page }}
        </a>
      </li>

      <!-- Ellipsis if necessary -->
      <li v-if="pageData.last_page > 3 && pageData.current_page < pageData.last_page - 1">
        <span>...</span>
      </li>

      <!-- Last Page -->
      <li v-if="pageData.last_page > 3">
        <a
            href="javascript:void(0)"
            @click="changePage(pageData.last_page)"
        >
          {{ pageData.last_page }}
        </a>
      </li>

      <!-- Next Page -->
      <li>
        <a
            id="nextPage"
            :class="{ disabled: pageData.current_page === pageData.last_page }"
            @click="pageData.current_page < pageData.last_page && changePage(pageData.current_page + 1)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 ml-[1px] lg:w-5 lg:h-5 lg:ml-[2px]">
            <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5"></path>
          </svg>
        </a>
      </li>

      <!-- Last Page -->
      <li>
        <a
            id="lastPage"
            :class="{ disabled: pageData.current_page === pageData.last_page }"
            @click="pageData.current_page < pageData.last_page && changePage(pageData.last_page)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevrons-right"><polyline points="13 17 18 12 13 7"></polyline><polyline points="6 17 11 12 6 7"></polyline></svg>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    pagination: {
      type: Object,
      required: true,
    },
  },
  computed: {
    pagesNumber() {
      const pagesArray = [];
      const { current_page, last_page } = this.pageData;

      // Dynamic page range
      const start = Math.max(1, current_page - 1);
      const end = Math.min(last_page, current_page + 1);

      for (let i = start; i <= end; i++) {
        pagesArray.push(i);
      }

      return pagesArray;
    },
  },
  data() {
    return {
      pageData: { ...this.pagination },
    };
  },
  watch: {
    pagination: {
      deep: true,
      handler(newVal) {
        this.pageData = { ...newVal };
      },
    },
  },
  methods: {
    changePage(page) {
      if (page !== this.pageData.current_page) {
        this.pageData.current_page = page;
        this.$emit('changePage', page);
      }
    },
  },
};
</script>

<style>
.retail_pagination .disabled {
  pointer-events: none;
  opacity: 0.5;
}

.retail_pagination .active {
  font-weight: bold;
}
</style>
